module.exports = __webpack_public_path__ + "img/AMAP.3fb58179.svg";